import { render } from "./ModalExcluirSelecionados.vue?vue&type=template&id=904d0522&scoped=true&ts=true"
import script from "./ModalExcluirSelecionados.vue?vue&type=script&lang=ts"
export * from "./ModalExcluirSelecionados.vue?vue&type=script&lang=ts"

import "./ModalExcluirSelecionados.vue?vue&type=style&index=0&id=904d0522&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-904d0522"]])

export default __exports__